export default "__VITE_ASSET__hQcZ4QOK__"